import { render, staticRenderFns } from "./DictItemList.vue?vue&type=template&id=2d16de15&scoped=true&"
import script from "./DictItemList.vue?vue&type=script&lang=js&"
export * from "./DictItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d16de15",
  null
  
)

export default component.exports